import create from 'zustand';
import produce from 'immer';

const ARTICLE_COURSE_INITIAL = {
	courses: []
};

export const useArticleCourseStore = create(set => ({
	...ARTICLE_COURSE_INITIAL,

	// Handle article's course addition
	onAdd: (course) => set(produce(state => {
		state.courses.push(course);
	})),

	// Handle article's course removal
	onRemove: (id) => set(produce(state => {
		state.courses = state.courses.filter(course => course.id !== id);
	})),

	// Initialize article's course state
	onInit: (courses) => set(produce(state => {
		state.courses = courses;
	})),

	// Reset store to initial state
	onReset: () => set({
		...ARTICLE_COURSE_INITIAL
	})
}));